import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseHttpService } from 'shared/base/_base-http.service';
import { Config } from 'shared/config/env.config';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class AttributesService extends BaseHttpService {
  getUom(): Observable<any> {
    return this.http.get(`${Config.API}/uom`)

      .pipe(map( (res) => {
        return res;
      }),
      catchError(this.handleError.bind(this)));
  }

  getPadbAttributeDetails(assignmentId: string): Observable<any> {
    return this.http.get(`${Config.API}/part-terminology/attribute-details/${assignmentId}`)
        .pipe(map( (res) => {
        return res;
      }),
            catchError(this.handleError.bind(this)));
  }
}
